export default {
  title: 'Yritystiedot',
  subtitle: 'Muokkaa Storefrontin yritystiedoissa näkyviä tietoja vaikuttamatta yritysprofiiliin.',
  defaultsNotice:
    'Kaikki kentät ovat valinnaisia. Jätä kenttä tyhjäksi, jos haluat käyttää yritysprofiilin arvoa — nykyinen oletusarvo näkyy esikatseluna harmaana. Kentän täyttäminen korvaa vain yritystiedot; yritysprofiilisi pysyy muuttumattomana.',
  fields: {
    legal_name: {
      label: 'Yrityksen / virallinen nimi',
      placeholder: 'esim. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Omistajan etunimi',
      placeholder: 'esim. Alex',
    },
    owner_last_name: {
      label: 'Omistajan sukunimi',
      placeholder: 'esim. Müller',
    },
    owner_email: {
      label: 'Sähköposti',
      placeholder: 'esim. info@example.com',
      invalid: 'Anna kelvollinen sähköpostiosoite',
    },
    owner_phone_number: {
      label: 'Puhelin',
      placeholder: 'esim. +49 30 1234567',
    },
    tax_id: {
      label: 'Y-tunnus',
      placeholder: 'esim. DE123456789',
    },
    address: {
      label: 'Osoite',
      placeholder: 'Katu, postinumero, kaupunki',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    saved: 'Yritystiedot tallennettu',
    failed: 'Yritystietojen tallennus epäonnistui',
  },
};
